import React from 'react';
import { Plus } from 'lucide-react';

const AddButton = ({ onClick, className = '', ...props }) => (
  <button
    onClick={onClick}
    className={`flex items-center justify-center w-10 h-10 rounded-full bg-red-500 hover:bg-red-600 text-white dark:text-black transition ${className}`}
    {...props}
  >
    <Plus className="h-5 w-5" />
  </button>
);

export default AddButton; 